module.exports = __webpack_public_path__ + "static/media/webcam.9f0afb70.svg";